export default __webpack_public_path__ + "static/c94f7671dcc99dce43e22a89f486f7c2.ttf";